<template>
  <c-box
    :title="'Динамика посещаемости сайта из посковых систем' + (data.length ? ' с ' + from.format('DD.MM.YYYY') : '')"
    shadow
    header-divider
    :loading="loading"
  >
    <div id="tpm-g">
      <c-line-chart
        v-if="!loading && data.length"
        :chart-data="chartData"
        :options="chartOptions"
        :height="100"
      />
    </div>
    <no-data v-if="!loading && !data.length" />
  </c-box>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import moment from 'moment'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import CLineChart from '../../../../../../../resources/js/components/ui/CLineChart.vue'
import { capitalizeFirstLetter } from '../../../../../../../resources/js/helper'

export default {
  name: 'TrafficPerMonth',
  components: { CLineChart, NoData, CBox },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        },
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'top',
            font: {
              weight: 'bold'
            }
          }
        }
      }
    }
  },
  computed: {
    from () {
      return this.data.length ? moment(this.data[0].ДатаНачала) : moment()
    },
    chartData () {
      return {
        labels: this.data.map(i => capitalizeFirstLetter(moment(i.ДатаОкончания).format('MMMM'))),
        datasets: [
          {
            data: this.data.map(i => i.КоличествоВизитов),
            fill: false,
            borderColor: '#ffb137',
            lineTension: 0
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #tpm-g {
    min-width: 1027px;
  }
</style>
